import { lazyWithRetry } from "utils/lazy-with-retry";
import { ISharePointProps } from "./definitions";

const LazySharePoint = lazyWithRetry(() => import("./SharePoint"));

const SharePoint = (props: ISharePointProps) => <LazySharePoint {...props} />;

export default SharePoint;
